import { useContext } from 'react';

import { ContextMenuContext } from '../context/ContextMenuContext';

export const useContextMenu = () => {
  const { contextMenu, setContextMenu } = useContext(ContextMenuContext);

  const showContextMenu = ({ x, y, options }) => {
    setContextMenu({
      show: true,
      x,
      y,
      options,
    });
  };

  const hideContextMenu = () => {
    setContextMenu(prev => ({
      ...prev,
      show: false,
      options: undefined,
    }));
  };

  return {
    contextMenu,
    showContextMenu,
    hideContextMenu,
  };
};
